import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({ email: "", password: "" });

    const APIurl = useSelector((state) => state.db.url);
    const validate = () => {
        let emailError = "";
        let passwordError = "";

        // Email validation
        if (!email) {
            emailError = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            emailError = "Email address is invalid";
        }

        // Password validation
        if (!password) {
            passwordError = "Password is required";
        } else if (password.length < 8) {
            passwordError = "Password must be at least 8 characters";
        }

        if (emailError || passwordError) {
            setErrors({ email: emailError, password: passwordError });
            return false;
        }

        setErrors({ email: "", password: "" });
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the form from refreshing the page

        try {
            const URL = `${APIurl}/api/kirtan/login`;
            const response = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Ensure the server expects JSON
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                }),
            });
            if (response.ok) {
                const result = await response.json();
                sessionStorage.setItem('token', JSON.stringify(result.token));
                navigate("/");
            } else {
                showAlertToast('error', 'Invalid email or password');
                console.error('error', response);
            }
        } catch (error) {
            showAlertToast('error', 'Invalid email or password');
            console.log('error: ', error);
        }

        const isValid = validate();
    };

    const showAlertToast = (type, message) => {
        console.log('type: ', type);
        console.log('message: ', message);
        switch (type) {
            case 'warn': toast.warn(message);
                break;
            case 'success': toast.success(message);
                break;
            case 'error': toast.error(message);
                break;
            case 'Alert': toast.alert(message);
                break;
            default:
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="login-container max-w-[425px] m-auto">
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="image-container flex items-center justify-center">
                        {/* Adjust image path as needed */}
                        {/* <img src="/images/Kundal_Logo.png"  alt="logo" loading="lazy" /> */}
                    </div>
                    <div className="form-group">
                        <h1>Login</h1>
                        <p>
                            <span className="text-[#2B72DE]">Welcome Back!</span> Please login to your account
                        </p>
                        <label htmlFor="email" className="mt-12 text-[14px] font-[500] tracking-[0.56px]">
                            Your Email
                        </label>
                        <input
                            className=" placeholder-[13px] text-black"
                            type="email"
                            id="email"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <p style={{ color: "#ff5858" }}>{errors.email}</p>}
                        <label htmlFor="password" className="mt-2 text-[14px] font-[500] tracking-[0.56px]">
                            Password
                        </label>
                        <div className="relative">
                            <input
                                className="placeholder-[13px] inputTextColor pr-10" // add padding-right to make space for the icon
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                placeholder="Minimum 8 characters"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                                className="absolute right-3 top-[25px] transform -translate-y-1/2 cursor-pointer"
                                onClick={() => setShowPassword((prevState) => !prevState)}
                            >
                                {showPassword ? <i class="fa-solid fa-eye"></i> : <i class="fa-solid fa-eye-slash"></i>}
                            </span>
                        </div>
                        {errors.password && <p style={{ color: "#ff5858" }}>{errors.password}</p>}

                        <button type="submit" className="login-button">
                            Login
                        </button>
                    </div>
                </form>
            </div >
        </>
    );
};

export default Login;
